module.exports = __webpack_public_path__ + "img/product-showcase-gallery-02.78f29020.jpg";